import { hyperdbHandlers } from 'hyperdb-utils';

const handlers = hyperdbHandlers({ namespace: 'AREA_CONTENT' });
export default {
  ...handlers,
  AREA_CONTENT__UPLOAD_PICTURE(state) {
    return { ...state, uploadingPicture: true, errorMessage: null, uploadSuccess: false };
  },
  AREA_CONTENT__UPLOAD_PICTURE_SUCCESS(state, { payload }) {
    const savedPicture = payload;
    return { ...state, savedPicture, uploadingPicture: false, errorMessage: null, uploadSuccess: true };
  },
  AREA_CONTENT__DELETE_PICTURE(state) {
    return { ...state, deletingPicture: true, errorMessage: null, deletePictureSuccess: false };
  },
  AREA_CONTENT__DELETE_PICTURE_SUCCESS(state) {
    return { ...state, deletingPicture: false, errorMessage: null, deletePictureSuccess: true };
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/content/area-content/handlers.js